import styles from './SiteInfo.module.scss';
import { useAppSelector } from '@customer/store/hooks';
import { useMemo } from 'react';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';

interface SiteData {
  siteName: string;
  siteTimezone: string;
}

export function SiteInfo() {
  const { showTimeZoneOffset } = useLocaleFormatter();

  const { isLoggedIn, siteContexts, siteId } = useAppSelector(state => state.auth);

  const siteData = useMemo<SiteData>(() => {
    if (isLoggedIn && siteContexts && siteContexts.length > 0 && siteId) {
      const matchedSite = siteContexts.find(s => s.id === siteId);
      if (matchedSite) {
        return {
          siteName: matchedSite.name,
          siteTimezone: showTimeZoneOffset(),
        };
      }
    }

    return {
      siteName: '',
      siteTimezone: '',
    };
  }, [showTimeZoneOffset, isLoggedIn, siteContexts, siteId]);

  return (
    <div className={styles.site_info}>
      <div className={styles.site_info__name}>{siteData.siteName}</div>
      <div className={styles.site_info__tz}>UTC {siteData.siteTimezone}</div>
    </div>
  );
}

export default SiteInfo;
